import React, { useEffect, useState } from "react";
import Button from "../../../../components/ui/Button/Button";
import Modal from "../../../../components/ui/Modal/Modal";
import CheckFactoryInventory from "./CheckFactoryInventory";

function CheckArea(props) {
  const { onSortBy } = props;
  const [triggerCloseModal, setTriggerCloseModal] = useState(false);

  const handleClose = () => {
    setTriggerCloseModal(true);
  };

  useEffect(() => {
    if (triggerCloseModal === true) {
      setTriggerCloseModal(false);
    }
  }, [triggerCloseModal]);

  return (
    <div className="mt-[2rem]">
      <div className="flex gap-6">
        <Modal
          hasCancel={false}
          hasSubmit={false}
          title="스마트팩토리 업데이트 재고 확인"
          padding="py-3"
          paddingTitle={`mx-8`}
          triggerClose={triggerCloseModal}
          rightTittle={
            <div className="flex -mr-5 items-center">
              <span className="mr-5">
                ※ 'API 연동'이 연동완료 된 재고에 한하여 '일괄 재고 연동하기'가
                가능합니다.
              </span>
              <Button
                onClick={handleClose}
                width="w-[5rem]"
                borderColor="border-button-grey border"
                text="닫기"
              />
            </div>
          }
          maxWidth="max-w-[70rem]"
          description={<CheckFactoryInventory />}
        >
          <button
            className={`bg-gradient-to-b from-white via-primary-white to-background-grey border border-button-grey h-7 w-[30rem] rounded-[4px]`}
          >
            스마트팩토리 업데이트 재고 확인
          </button>
        </Modal>
        <div className="bg-[#f2f2f4] h-7 flex gap-3 items-center px-4 w-full">
          <div className="w-16">
            <span className="font-bold m-auto">정렬 필터</span>
          </div>
          <div className="flex gap-3">
            <div className="flex gap-1 items-center">
              <>
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id="STOCK_DESC"
                  value="STOCK_DESC"
                  name="orderBy"
                  onChange={onSortBy}
                />
                <label htmlFor="STOCK_DESC">재고 많은 순</label>
              </>
            </div>
            <div className="flex gap-1 items-center">
              <>
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id="STOCK_ASC"
                  value="STOCK_ASC"
                  name="orderBy"
                  onChange={onSortBy}
                />
                <label htmlFor="STOCK_ASC">재고 적은 순</label>
              </>
            </div>
            <div className="flex gap-1 items-center">
              <>
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id="REF_ASC"
                  value="REF_ASC"
                  name="orderBy"
                  onChange={onSortBy}
                />
                <label htmlFor="REF_ASC">REF(상품코드)</label>
              </>
            </div>
            <div className="-mx-1">|</div>
            <div className="flex gap-1 items-center">
              <>
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id="d"
                  value="d"
                  name="qtyBy"
                  onChange={(event) => {}}
                />
                <label htmlFor="d">10개 보기</label>
              </>
            </div>
            <div className="flex gap-1 items-center">
              <>
                <input
                  type="radio"
                  className="flex-none accent-primary-black"
                  id="e"
                  value="e"
                  name="qtyBy"
                  onChange={(event) => {}}
                />
                <label htmlFor="e">30개 보기</label>
              </>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckArea;
